export const trackerTypes = {
    PRIVATE: 'private',
    PUBLIC: 'public',
    ECOSYSTEMS: 'ecosystems',
    POC: 'POC',
    REQUEST: 'request',
};

export const trackerTypesLabels = {
    'private': 'Private',
    'public': 'Public',
    'ecosystems': 'Ecosystems',
    'POC': 'POC',
};

export const visualizationTypes = {
    LIST: 'private',
    PIPELINE: 'pipeline',
    TIMELINE: 'timeline',
};

export const visualizationTypesLabels = {
    'list': 'List',
    'pipeline': 'Pipeline',
    'timeline': 'Timeline',
};

export const filterTypesByCreator = {
    'all': 'All Trackers',
    'created-by-me': 'Created By Me',
    'related-to-me': 'Related To Me',
}
